import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TCounterpartiesListResData,
  TCounterpartiesListReqParams,
  TUpdateCounterpartyReqData,
  TCreateCounterpartyReqData,
  TUpdateCounterpartyResData,
  TCreateCounterpartyResData,
  TCounterpartyAssetsReqParams,
  TCounterpartyAssetsResData,
} from '../types/counterparty.types';

export const getCounterpartiesListService = async (
  params: TCounterpartiesListReqParams = {},
): Promise<TCounterpartiesListResData> => {
  const config = {
    params,
  };
  const url = API_ENDPOINTS.COUNTERPARTIES.COUNTERPARTIES;
  const res = await apiClient.get<TCounterpartiesListResData>(url, config);
  return res.data;
};

export const updateCounterpartyService = async (
  guid: string,
  data: TUpdateCounterpartyReqData,
): Promise<TUpdateCounterpartyResData> => {
  const url = API_ENDPOINTS.COUNTERPARTIES.COUNTERPARTY_UPDATE.replace(EApiPathParams.CounterpartyGuid, guid);
  const res = await apiClient.put<TUpdateCounterpartyResData>(url, data);

  return res.data;
};

export const createCounterpartyService = async (
  data: TCreateCounterpartyReqData,
): Promise<TCreateCounterpartyResData> => {
  const url = API_ENDPOINTS.COUNTERPARTIES.COUNTERPARTIES;
  const res = await apiClient.post<TCreateCounterpartyResData>(url, data);

  return res.data;
};

export const getCounterpartyAssetsService = async (
  counterpartyGUID: string,
  params: TCounterpartyAssetsReqParams = {},
): Promise<TCounterpartyAssetsResData> => {
  const url = API_ENDPOINTS.ASSETS.COUNTERPARTY_ASSETS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<TCounterpartyAssetsResData>(url, config);

  return res.data;
};

export const getCounterpartyAssets = async (
  counterpartyGUID: string,
  params: TCounterpartyAssetsReqParams = {}
): Promise<TCounterpartyAssetsResData> => {
  const url = API_ENDPOINTS.ASSETS.COUNTERPARTY_ASSETS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<TCounterpartyAssetsResData>(url,config);
  return res.data;
};
